import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Hook : révèle un élément au scroll
export const useInView = (options = { threshold: 0.12 }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setInView(true);
        obs.unobserve(el);
      }
    }, options);
    obs.observe(el);
    return () => obs.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return [ref, inView];
};

export const Reveal = ({ children, delay = 0, className = "" }) => {
  const [ref, inView] = useInView();
  return (
    <div
      ref={ref}
      className={`reveal ${inView ? "reveal-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};

// Titre de section style Exacom : — Titre —
export const SectionTitle = ({ children, light = false }) => (
  <div className="flex items-center justify-center gap-4 mb-12">
    <span className={`h-[3px] w-10 rounded-full ${light ? "bg-white/70" : "bg-[#2f6fd8]"}`} />
    <h2
      className={`text-2xl md:text-4xl font-medium tracking-wide text-center ${
        light ? "text-white" : "text-[#1b2653]"
      }`}
    >
      {children}
    </h2>
    <span className={`h-[3px] w-10 rounded-full ${light ? "bg-white/70" : "bg-[#2f6fd8]"}`} />
  </div>
);

// Bouton pill style Exacom
export const PillButton = ({ to, children, dark = false, onClick, type }) => {
  const cls = `inline-flex items-center justify-center rounded-full px-8 py-3.5 text-[13px] font-semibold uppercase tracking-[0.18em] transition-colors duration-300 ${
    dark
      ? "bg-[#1b2653] text-white hover:bg-[#2f6fd8]"
      : "bg-white text-[#1b2653] hover:bg-[#2f6fd8] hover:text-white"
  }`;
  if (to) {
    return (
      <Link to={to} className={cls} onClick={() => window.scrollTo({ top: 0 })}>
        {children}
      </Link>
    );
  }
  return (
    <button type={type || "button"} onClick={onClick} className={cls}>
      {children}
    </button>
  );
};

// Bannière d'en-tête des pages internes
export const PageHero = ({ title, subtitle, image }) => (
  <section className="relative flex items-center justify-center min-h-[42vh] md:min-h-[50vh] overflow-hidden">
    <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-[#141d43]/80" />
    <div className="relative z-10 text-center px-6 pt-24 pb-12">
      <h1 className="text-3xl md:text-5xl font-semibold text-white tracking-wide mb-4">{title}</h1>
      {subtitle && (
        <p className="text-white/80 max-w-2xl mx-auto text-base md:text-lg font-light">{subtitle}</p>
      )}
    </div>
  </section>
);

export const ScrollToTop = () => {
  return null;
};
